var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel panel-user" },
    [
      _c(
        "div",
        { staticClass: "row no-gutters icons justify-content-center" },
        [
          _c("ul", { staticClass: "nav" }, [
            _c(
              "li",
              { staticClass: "nav-item icon" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.profile" } } },
                  [
                    _c("img", { attrs: { src: _vm.profileIcon, alt: "" } }),
                    _vm._v(" "),
                    _c("label", [_vm._v(_vm._s(_vm.$t(`auth.profile`)))]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "nav-item icon mx-3" },
              [
                _c("router-link", { attrs: { to: { name: "portal.home" } } }, [
                  _c("img", { attrs: { src: _vm.PortalIcon, alt: "" } }),
                  _vm._v(" "),
                  _c("label", [_vm._v(_vm._s(_vm.$t(`auth.portal`)))]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.$auth.check()
              ? _c(
                  "li",
                  { staticClass: "nav-item icon", on: { click: _vm.logout } },
                  [
                    _c("img", { attrs: { src: _vm.logoutIcon, alt: "" } }),
                    _vm._v(" "),
                    _c("label", [_vm._v(_vm._s(_vm.$t(`auth.logout`)))]),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._t("panel-section-user"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-sm-12 modules" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }